import React from 'react';
import PropTypes from 'prop-types';
import usePaymentMethods from 'components/Common/Billing/Hooks/usePaymentMethods';
import Select from 'react-select';
import { Row, Col } from 'react-bootstrap';

import renewalMethods from 'data/renewal_method_statuses';
import plasStatuses from 'data/policy_plan_statuses';

import { useContext } from '../../Context';

export default function Filters({ setPaymentMethod, setRenewalMethod, setStatus }) {
  const { state } = useContext();

  const paymentMethods = usePaymentMethods(state.enterpriseId);

  const paymentMethodsOptions = paymentMethods
    ? [
      { value: 'free', label: 'Free' },
      ...paymentMethods.map((item) => ({ value: item.id, label: item.attributes.label })),
    ]
    : [];

  return (
    <Row className="mt20">
      <Col md={4}>
        <Select
          isClearable
          isSearchable
          placeholder={
            paymentMethods ? 'Filter by Payment Method' : 'Payment Method Loading ...'
          }
          onChange={(option) => {
            setPaymentMethod(option == null ? null : option.value);
          }}
          options={paymentMethodsOptions}
        />
      </Col>

      <Col md={4}>
        <Select
          isClearable
          isSearchable
          placeholder="Filter by Renewal Method"
          onChange={(option) => {
            setRenewalMethod(option == null ? null : option.value);
          }}
          options={renewalMethods}
        />
      </Col>
      <Col md={4}>
        <Select
          isClearable
          isSearchable
          placeholder="Filter by Status"
          onChange={(option) => {
            setStatus(option == null ? null : option.value);
          }}
          options={plasStatuses}
        />
      </Col>
    </Row>
  );
}

Filters.propTypes = {
  setPaymentMethod: PropTypes.func.isRequired,
  setRenewalMethod: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};
